import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ConfirmModalWrapper } from './styles';

class ConfirmModal extends Component {
  handleCancel = () => {
    const { onClose } = this.props;
    onClose();
  }

  handleAccept = () => {
    const { onAccept } = this.props;
    onAccept();
  }

  render() {
    const { open, confirmText, literals } = this.props;
    return (
      <ConfirmModalWrapper
        open={open}
        onClose={this.handleCancel}
        style={{ zIndex: 1110000 }}
      >
        <div className='modal confirm_modal'>
          <div className='modal_text'>
            {confirmText}
          </div>
          <div className='buttons'>
            <button className='primary' onClick={this.handleAccept}>
              {literals.accept}
            </button>
            <button className='danger' onClick={this.handleCancel}>
              {literals.cancel}
            </button>
          </div>
        </div>
      </ConfirmModalWrapper>
    );
  }
}

ConfirmModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  confirmText: PropTypes.string.isRequired,
  literals: PropTypes.object.isRequired,
};

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/components/ConfirmModal/components/index.jsx